
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export async function uploadFileToStorage(file: File, folder: string, profileId: string): Promise<string | null> {
  try {
    const fileExt = file.name.split('.').pop();
    const randomId = Math.random().toString(36).substring(2, 15);
    const fileName = `${folder}-${profileId}-${randomId}.${fileExt}`;
    const filePath = `${folder}/${fileName}`;

    const { error: uploadError, data } = await supabase.storage
      .from('profiles')
      .upload(filePath, file, {
        cacheControl: "3600",
        upsert: true
      });

    if (uploadError) {
      console.error(`Error uploading ${folder} image:`, uploadError);
      toast.error(`Error uploading ${folder} image`);
      return null;
    }

    const { data: publicUrlData } = await supabase.storage
      .from('profiles')
      .getPublicUrl(filePath);

    return publicUrlData.publicUrl;
  } catch (error) {
    console.error(`Error in ${folder} upload:`, error);
    toast.error("An error occurred during upload");
    return null;
  }
}
